import { render } from "./TodoCardUpdateEntrega.vue?vue&type=template&id=06be6aa4"
import script from "./TodoCardUpdateEntrega.vue?vue&type=script&lang=js"
export * from "./TodoCardUpdateEntrega.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__